import { get, put, del, patch, post } from 'utils/fetch';
import endpoints, { EEndpoints } from 'config/endpoints';
import { users as typesUsers } from 'types';
import {
    TGetUserActivityLogDetailRequest,
    TGetUserActivityLogDetailResponse,
    TGetUserActivityLogsResponse,
} from 'types/entities/user-activity-logs';
import { TUserEkycSetResponse } from 'types/entities/users';

const users = {
    unlock({ id }: typesUsers.TUserIdParams) {
        return put<null, null>(`${endpoints[EEndpoints.usersUnlock](id)}`);
    },
    lock({ id }: typesUsers.TUserIdParams) {
        return put<null, null>(`${endpoints[EEndpoints.usersLock](id)}`);
    },
    pinReset({ id }: typesUsers.TUserIdParams) {
        return put<null, null>(`${endpoints[EEndpoints.usersPinReset](id)}`);
    },
    // get() {
    //     return get<typesUsers.TUsers[]>(`${endpoints[EEndpoints.users]()}`);
    // }, // OLD
    get({ query }: { query: string }) {
        return get<typesUsers.TUsersResponse>(
            `${endpoints[EEndpoints.users]()}?${query}`,
        );
    },
    getById(id: string) {
        return get<typesUsers.TUsersDetail>(
            `${endpoints[EEndpoints.usersDetail](id)}`,
        );
    },
    del({ id, reason }: typesUsers.TUserDelParams) {
        return del<null>(
            `${endpoints[EEndpoints.usersDel](id)}?reason=${reason}`,
        );
    },
    suspend({ id, reason }: typesUsers.TUserSuspendParams) {
        return patch<{ reason: string }, null>(
            `${endpoints[EEndpoints.usersSuspend](id)}`,
            {
                reason,
            },
        );
    },
    activate({ id }: typesUsers.TUserIdParams) {
        return patch<{}, null>(`${endpoints[EEndpoints.usersActivate](id)}`);
    },
    e_kyc_get({ id }: typesUsers.TUserIdParams) {
        return get<typesUsers.TUser_e_kyc_getResp>(
            `${endpoints[EEndpoints.usersEKycGet](id)}`,
        );
    },
    e_kyc_set({
        id,
        params,
    }: {
        id: string;
        params: typesUsers.TUser_e_kyc_setParams;
    }) {
        return put<typesUsers.TUser_e_kyc_setParams, TUserEkycSetResponse>(
            `${endpoints[EEndpoints.usersEKycSet](id)}`,
            params,
        );
    },
    getEkyDetailByUserId(id: string) {
        return get<typesUsers.IGetEKYCDetailsResponse>(
            `${endpoints[EEndpoints.usersEKycGet](id)}`,
        );
    },
    revalidateCft({ id }: { id: string }) {
        return post<{}, null>(
            `${endpoints[EEndpoints.revalidateCftByUserId](id)}`,
            {},
        );
    },
    revalidateKtp({ id }: { id: string }) {
        return post<{}, null>(
            `${endpoints[EEndpoints.revalidateKtpByUserId](id)}`,
            {},
        );
    },
    getUserActivityLogs({ query }: { query: string }) {
        return get<TGetUserActivityLogsResponse>(
            `${endpoints[EEndpoints.userActivityLogs]()}?${query}`,
        );
    },
    getUserActivityLogDetail({ id }: TGetUserActivityLogDetailRequest) {
        return get<TGetUserActivityLogDetailResponse>(
            `${endpoints[EEndpoints.userActivityLogDetail](id)}`,
        );
    },
};

export default users;
